(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire31b9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire31b9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4lfHS", function(module, exports) {

var $aFde5 = parcelRequire("aFde5");
const page = ()=>{
    if (document.querySelector('#iddapageexample')) return 0, $aFde5.default;
    else return null;
};
if (!page()) return;
const app = Vue.createApp(page());
app.mount("#app");
window.instance = app;

});
parcelRegister("aFde5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c37fe2ae7f82699$export$2e2bcd8739ae039; });
var $7c37fe2ae7f82699$export$2e2bcd8739ae039 = {
    data () {
        return {};
    },
    delimiters: [
        "{*",
        "*}"
    ]
};

});



parcelRequire("4lfHS");
})();
//# sourceMappingURL=index.js.map
